import gql from 'graphql-tag';







export const GET_SHOOTSTA_ADMIN_AUDIT_LOGS = gql`
  query getShootstaAdminAuditLogsByOrganisationId(
    $organisationId: String!
    $filters: Filters
  ) {
    getShootstaAdminAuditLogsByOrganisationId(
      organisationId: $organisationId
      filters: $filters
    ) {
      summary {
        totalProjects
        totalCredits
        totalFlex
        totalAdvanced
        totalAddonsCost {
          cost
          billingEntityCode
        }
      }
      auditLogs {
        invoiceId
        paymentStatus
        type
        subType
        usage
        createdAt
        showDetails
        projectId
        creditSegregation {
          CREDITS
          THIS_MONTH_CREDITS
          TOPUP_CREDITS
          BUFFER_CREDITS
        }
        addonsCost {
          cost
          billingEntityCode
        }
        createdBy {
          firstName
          lastName
        }
        description {
          type
          message
        }
        credits,
        isProjectDeleted
      }
    }
  }
`;

const getShootstaAdminAuditLogsByOrganisationId = (organisationId) => ({
  query: GET_SHOOTSTA_ADMIN_AUDIT_LOGS,
  module: 'reporting',
  ignoreCache: true,
  buildVariables: (filters) => ({
    organisationId,
    filters
  }),
  isSilent: true
});

export default getShootstaAdminAuditLogsByOrganisationId;